import React from 'react';

import ListItem from '@material-ui/core/ListItem';

import styles from './Clue.module.scss';

export default class Clue extends React.Component {
  onClickClue = () => {
    const { clue = {}, onClickClueFunc } = this.props;
    onClickClueFunc(clue);
  };

  render() {
    const { clue = {} } = this.props;
    const { name = '', type = '' } = clue;
    return (
      <ListItem className={styles.root} onClick={this.onClickClue}>
        <div className={styles.clue}>
          <div className={styles.largeColumn}>{name}</div>
          <div className={styles.largeColumn}>
            <span className={styles.action}>{type}</span>
          </div>
        </div>
      </ListItem>
    );
  }
}
